module.exports = __webpack_public_path__ + "static/media/logo-word.c8b60c30.svg";